import { defineComponent as D, ref as z, useSlots as E, watch as N, withDirectives as I, openBlock as r, createElementBlock as d, normalizeClass as o, withModifiers as T, createVNode as V, Transition as R, withCtx as j, createElementVNode as f, createCommentVNode as s, unref as u, renderSlot as c, vShow as L, pushScopeId as H, popScopeId as O } from "vue";
import { _ as q } from "../_plugin-vue_export-helper-CHgC5LLL.js";
import '../Modal.css';const A = (a) => (H("data-v-e8631f3f"), a = a(), O(), a), F = ["id", "aria-modal", "data-modal-placement"], G = /* @__PURE__ */ A(() => /* @__PURE__ */ f("svg", {
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ f("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)), J = [
  G
], K = /* @__PURE__ */ D({
  __name: "Modal",
  props: {
    open: { type: Boolean, default: !1 },
    id: { default: "" },
    width: { default: "default" },
    placement: { default: "center" },
    headerDivider: { type: Boolean, default: !1 },
    footerDivider: { type: Boolean, default: !1 },
    borderRadius: { type: Boolean, default: !0 },
    border: { type: Boolean, default: !0 },
    clearIcon: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    classes: { default: () => ({}) },
    backdropClose: { type: Boolean, default: !0 },
    backdropBlur: { type: Boolean, default: !1 },
    escapeClose: { type: Boolean, default: !0 }
  },
  emits: ["onClose"],
  setup(a, { emit: M }) {
    const t = a, l = z(t.open), S = M, n = () => {
      l.value = !1, setTimeout(() => {
        S("onClose", !1);
      }, 300);
    }, i = E(), m = (e) => {
      var p;
      t.open && ((p = e == null ? void 0 : e.key) == null ? void 0 : p.toLowerCase()) === "escape" && n();
    };
    N(
      () => t.open,
      (e) => {
        e && setTimeout(() => {
          l.value = !0;
        }, 50), t.escapeClose && (e ? document.addEventListener("keydown", m) : document.removeEventListener("keydown", m));
      }
    );
    const $ = () => {
      t.backdropClose && n();
    };
    return (e, p) => {
      var h;
      return I((r(), d("div", {
        id: e.id,
        tabindex: "-1",
        role: "alertdialog",
        "aria-modal": e.open,
        "data-modal-placement": `modal-${e.placement}`,
        class: o([
          "fixed !z-50 w-full p-4 overflow-x-hidden overflow-y-auto h-modal modal !opacity-100 visible modal-container",
          `modal-${e.placement}`,
          { "!hidden": !e.open },
          { "backdrop-blur": e.backdropBlur },
          (h = e.classes) == null ? void 0 : h.overlayContainer
        ]),
        "aria-hidden": "",
        onClick: T($, ["self", "exact"])
      }, [
        V(R, { name: "modal-fade" }, {
          default: j(() => {
            var y, v, b, w, k, g, C, B;
            return [
              I(f("div", {
                class: o([
                  "relative h-full md:h-auto bg-app-white dark:bg-app-gray-700 pointer-events-auto",
                  "transition duration-300 ease-in-out origin-center",
                  `modal-size-${e.width}`,
                  { "rounded-lg": e.borderRadius, shadow: e.shadow, "border dark:border-app-gray-700": e.border },
                  (y = e.classes) == null ? void 0 : y.modalContent
                ])
              }, [
                e.clearIcon ? (r(), d("button", {
                  key: 0,
                  type: "button",
                  class: o([
                    "absolute right-1 top-1 text-app-gray-400 bg-transparent hover:text-app-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:text-app-white",
                    (v = e.classes) == null ? void 0 : v.clearIcon
                  ]),
                  "data-modal-hide": "staticModal",
                  onClick: n
                }, J, 2)) : s("", !0),
                (b = u(i)) != null && b.header ? (r(), d("div", {
                  key: 1,
                  class: o([
                    "flex items-start justify-between px-6 py-4 border-app-gray-200 dark:border-app-gray-600",
                    { "border-b": e.headerDivider },
                    (w = e.classes) == null ? void 0 : w.header
                  ])
                }, [
                  c(e.$slots, "header", {}, void 0, !0)
                ], 2)) : s("", !0),
                (k = u(i)) != null && k.body ? (r(), d("div", {
                  key: 2,
                  class: o(["px-6 py-4 space-y-6", (g = e.classes) == null ? void 0 : g.body])
                }, [
                  c(e.$slots, "body", {}, void 0, !0)
                ], 2)) : s("", !0),
                (C = u(i)) != null && C.footer ? (r(), d("div", {
                  key: 3,
                  class: o([
                    "flex items-center px-6 py-4 space-x-2 border-app-gray-200 dark:border-app-gray-600",
                    { "border-t": e.footerDivider },
                    (B = e.classes) == null ? void 0 : B.footer
                  ])
                }, [
                  c(e.$slots, "footer", {}, void 0, !0)
                ], 2)) : s("", !0)
              ], 2), [
                [L, l.value]
              ])
            ];
          }),
          _: 3
        })
      ], 10, F)), [
        [L, l.value]
      ]);
    };
  }
}), U = /* @__PURE__ */ q(K, [["__scopeId", "data-v-e8631f3f"]]);
export {
  U as default
};
//# sourceMappingURL=Modal.esm.js.map
